// import React, { Component } from 'react'
// import { DropzoneArea } from 'material-ui-dropzone'

// class DropzoneAreaExample extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       files: []
//     }
//   }
//   handleChange(files) {
//     this.setState({
//       files: files
//     })
//   }
//   render() {
//     return <DropzoneArea onChange={this.handleChange.bind(this)} />
//   }
// }

// export default DropzoneAreaExample

import React, { Component } from 'react'
import { DropzoneDialog } from 'material-ui-dropzone'
import Button from 'components/CustomButtons/Button.jsx'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { getToken } from '../utility/utility'

import swal from 'sweetalert'
import { getDataServer, logger } from '../utility/utility'

const dataServer = getDataServer()

const styles = theme => ({
  buttons: {
    marginLeft: 'auto'
  }
})

class DropzoneDialogExample extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dir: this.props.dir,
      open: false,
      files: []
    }
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  // handleSave(files) {
  //   //Saving files to state for further use and closing Modal.
  //   this.setState({
  //     files: files,
  //     open: false
  //   })
  // }

  handleOpen() {
    this.setState({
      open: true
    })
  }
  handleSave(files) {
    let data = new FormData()
    const existedFilesOnServer = this.props.attached.map(f => f.name)

    files.map(f => {
      if (existedFilesOnServer && existedFilesOnServer.includes(f.name)) {
        swal('Warning', `File ${f.name} already existed in the server, rename it before uploading.`, 'warning')
      } else {
        // oh, damn, it doesn't ahve to be append('files[]', f) , not sure this is good or not
        data.append('files', f)
      }
    })
    //data.append('id', this.state.dir)
    logger('[FileUploader][handleSave]:', { dataServer })
    fetch(dataServer + '/filesupload/' + this.state.dir, {
      method: 'POST',
      headers: new Headers({
        authorization: getToken()
      }),
      body: data
    })
      .then(response => {
        logger('[FileUploader][handleSave]:', { response })
        return response.json()
      })
      .then(data => {
        // console.log(data)
        this.props.onChange ? this.props.onChange(data.map(file => ({ name: file.filename }))) : alert('missing a callback for file upload widget')
        this.handleClose()
      })
      .catch(e => logger('[FileUploader][handleSave]:', { e }))
  }
  render() {
    // console.log(this.props)
    return (
      <div
        className={classNames({
          [this.props.classes.buttons]: this.props.rightAlign
        })}
      >
        <Button color='rose' onClick={this.handleOpen.bind(this)}>
          Add Files
        </Button>
        <DropzoneDialog
          open={this.state.open}
          onSave={this.handleSave.bind(this)}
          //ppt: application/vnd.openxmlformats-officedocument.wordprocessingml.presentation
          //word: application/vnd.openxmlformats-officedocument.wordprocessingml.document
          //excel: ....sheet
          //pdf: application/pdf
          acceptedFiles={[
            'image/jpg',
            'image/jpeg',
            'image/png',
            'image/bmp',
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.presentation',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.sheet',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // ms excel
            'message/rfc822' // .msg file
          ]} //
          showPreviews={true}
          maxFileSize={20000000}
          onClose={this.handleClose.bind(this)}
        />
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(DropzoneDialogExample)
